var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35_6476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.605,
    cy: 32.7007,
    r: 22.7222,
    fill: "#262B23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6508 35.3658C37.3019 35.3658 41.0691 31.6644 41.0691 27.0945C41.0691 22.5246 37.3019 18.8232 32.6508 18.8232C27.9997 18.8232 24.2325 22.5246 24.2325 27.0945C24.2325 31.6644 27.9997 35.3658 32.6508 35.3658ZM32.6508 39.5015C27.0315 39.5015 18.6241 41.9393 17.6641 46.7925C17.6641 46.7925 23.3683 53.4252 32.8567 53.1772C42.3451 52.9292 47.5887 46.6835 47.5887 46.6835C45.0918 40.9405 38.27 39.5015 32.6508 39.5015Z",
    fill: "#D9FF43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35_6476",
    x: 0.415225,
    y: 0.510928,
    width: 64.3805,
    height: 64.3795,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.73379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35_6476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35_6476",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicIcon);
export default __webpack_public_path__ + "static/media/ProfilePicIcon.dde9ffdb6bd0fd6f1fd76a5bc063dbfe.svg";
export { ForwardRef as ReactComponent };